<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <!--Vertical y horizontal-->
          <v-flex xs12 sm8 md6>
            <v-alert type="error" dismissible v-model="alert">
              {{ error }}
            </v-alert>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Restablecer contraseña</v-toolbar-title>
              </v-toolbar>
              <form @submit.prevent="passwordRestore">
                <v-card-text>
                  <v-text-field
                    autofocus
                    required
                    id="email"
                    prepend-icon="email"
                    name="email"
                    label="Correo electrónico"
                    v-model="email"
                    type="email"
                    counter
                    maxlength="70"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" type="submit" :disabled="loading">
                    Enviar
                  </v-btn>
                </v-card-actions>
              </form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
// Formulario para restaurar una contraseña olvidada
// @group Formularios de entrada
export default {
  name: "RestorePassword",
  data() {
    return {
      email: "",
      alert: false
    };
  },
  methods: {
    // @vuese
    // Restaurar contraseña
    // @arg El email del usuario
    passwordRestore() {
      this.$store.dispatch("passwordRestore", {
        email: this.email.trim()
      });
    }
  },
  computed: {
    // @vuese
    // Indica el error
    error() {
      return this.$store.state.error;
    },
    // @vuese
    // Indica si el sistema está cargando
    loading() {
      return this.$store.state.loading;
    }
  },
  watch: {
    error(value) {
      if (value) {
        this.alert = true;
      }
    },
    alert(value) {
      if (!value) {
        this.$store.commit("setError", null);
      }
    }
  }
};
</script>
